<template>
  <div>
    <div class="box">
      <BInputPullDown
        label-name="机构名称"
        v-model="searchParam.organizationId"
        :Options="orgList"
        placeholder="请选择机构名称"
      />
      <BInputText
        label-text="班级名称"
        v-model="ClassName"
        placeholder="请输入班级名称"
      />
      <BInputText
        label-text="学员"
        v-model="NameID"
        placeholder="姓名"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-result-summary">
          <div class="summary">学员：{{ studentTotalNum }}人</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:learnRates="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div style="width:60%;margin-right:-20px;">
              <BProgressStudy v-model="item.data.learnRate" style="width: 100px;" />
            </div>
            <div style="width:15%;margin-top:3px;">{{item.data.learnRate}}%</div>
          </div>
        </template>
        <template v-slot:actions="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div class="btn-detail" @click="handleDetail(item)">详情</div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>

import { searchList, listSearchInit } from '@/api/admStudent'
import BInputText from "../../components2/BInputText";
import Table from "../../components2/Table";
import BBtnSecondary from "../../components2/BBtnSecondary";
import BProgressStudy from "../../components2/BProgressStudy";
import BInputPullDown from "../../components2/BInputPullDown";
export default {
  name: "adm_student_list",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
    BProgressStudy,
    BInputPullDown,
  },
  data: () => ({
    id: 0,
    pageNum: 1,
    limit: 10,
    pageCount: 10,
    totalCount: 0,
    searchParam: {},
    studentTotalNum: 0,
    timeout: 3000,
    snackbarColor: "",
    snackbarText: "",
    totalPages: 0,
    page: 1,
    NameID: "",
    ClassName: "",
    userName: "",
    idCard: "",
    data: {},
    loading: false,
    snackbar: false,
    snackbarObj: {
      snackbar: false,
      timeout: -1,
      color: "",
      text: "",
    },
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '3%' },
      { text: "姓名", value: "userName", sortable: false, align: "center", width: '10%' },
      { text: "班级名称", value: "className", sortable: false, align: "left", width: '15%' },
      { text: "性别", value: "sex", sortable: false, align: "center", width: '8%' },
      { text: "年龄", value: "age", sortable: false, align: "center", width: '8%' },
      { text: "手机号码", value: "telNo", sortable: false, align: "center", width: '10%' },
      { text: "学习进度", value: "learnRates", sortable: false, align: "center", width: '15%' },
      { text: "添加时间", value: "createTime", sortable: false, align: "center", width: '15%' },
      { text: "操作", value: "actions", sortable: false, align: "center" },
    ],
    pageList: [],
    data_status:'',
    navi: [{ name: "adm_student_list" }],
    orgList: [],
  }),
  created() {
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 页面初期化
      vm.init()
    });
  },
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  mounted() {
  },
  methods: {
    // 初始化
    async init () {
      const data = await listSearchInit()
      this.orgList = data.data.orgList
      this.searchParam.organizationId = this.orgList[0].value
      this.doSearch(true)
    },
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
      } 
      this.searchList();
    },
    async searchList() {
      // if (isNaN(this.NameID)) {
      //   this.userName = this.NameID;
      //   this.idCard = "";
      // } else {
      //   this.idCard = this.NameID;
      //   this.userName = "";
      // }
      var param = {
        page: this.page,
        limit: this.limit,
        organizationId: this.searchParam.organizationId,
        classId: this.ClassName,
        userName: this.NameID,
        // idCard: this.idCard,
      };
      const data = await searchList(param);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.pageList = data.data.searchList;
        this.studentTotalNum = data.data.studentTotalNum;
      }
      this.totalCount = data.data.totalPage;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
    },
    
    // 点击详情
    handleDetail(item) {
      this.$router.push({
        name: 'adm_class-student-detail',
        params: { 
          id: item.data.userId,
          classId: item.data.classId,
          studentId: item.data.studentId,
          bbxUserInfoId: item.data.bbxUserInfoId,
        },
      })
    },
  },

  destroyed() {
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  float: right;
  /*top: 0;*/
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  margin: 0 10px 0 20px;
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.btn-reset {
  margin: 0 10px 0 10px;
  color: #0171a3;
  cursor: pointer;
}

</style>
